

// Runs every query in the shopper's market (window.api.country) so prices,
// currency, availability and price filters match what Liquid renders — e.g. a
// $149 USD dress is $215 CAD for a Canadian shopper. Adds a $country variable
// and @inContext to the query's operation definition.
const operationPattern = /\b(query|mutation)(\s+\w+)?\s*(?:\(([^)]*)\))?\s*\{/;

function withCountryContext(query, variables) {
  const country = window.api?.country;

  if (!country || !query || query.includes("@inContext") || !operationPattern.test(query)) {
    return { query, variables };
  }

  return {
    query: query.replace(operationPattern, (match, operation, name = "", args) => {
      const params = args?.trim() ? `${args}, $country: CountryCode` : "$country: CountryCode";

      return `${operation}${name}(${params}) @inContext(country: $country) {`;
    }),
    variables: { ...variables, country },
  };
}

class Storefront {

  get headers() {
    return {
      "X-Shopify-Storefront-Access-Token": (window.api && window.api.token) || "",
      "Content-Type": "application/json",
    };
  }

  request = async ({ query, variables = {} }) => {
    if (!window.api || !window.api.token || !window.api.shop) {
      console.error("There was an error with the storefront token.");
      return undefined;
    }

    const url = `https://${window.api.shop}/api/${window.api.version}/graphql.json`;

    let response;
    try {
      response = await fetch(url, {
        headers: this.headers,
        method: "POST",
        body: JSON.stringify(withCountryContext(query, variables)),
      });
    } catch (error) {
      console.error("Storefront API request failed.", error);
      return undefined;
    }

    if (!response.ok) {
      console.error(`Storefront API request failed with status ${response.status}.`);
      return undefined;
    }

    const json = await response.json();

    if (json.errors) {
      console.error("Storefront API returned errors.", json.errors);
    }

    return json;
  };
}

export default new Storefront();
